export const CLAIM_S = 'claim(s)'
export const ISSUE_S = 'issue(s)'

export const OUTBOUND_SUPPORT = 'support@outbound.ai'
export const MAINTENANCE_STORAGE_KEY = 'maintenanceNotification'
